import { useEffect } from 'react';
import { injectScript } from '@/util';

let freshdeskHasLoaded = false;

export const useFreshDeskWidget = () => {
    // Checks the script has never been injectd before, and injects it.
    const setupFreshDeskScript = async () => {
        if (!freshdeskHasLoaded) {
            // Add the provided code snippet here
            window.fwSettings = {
                widget_id: 157000001292
            };

            if (typeof window.FreshworksWidget !== 'function') {
                const n = function initializeN(...args) {
                    initializeN.q.push(args);
                };
                n.q = [];
                window.FreshworksWidget = n;
            }

            await injectScript({
                id: 'fd-snippet',
                url: 'https://widget.freshworks.com/widgets/157000001292.js'
            });

            window.FreshworksWidget('hide', 'launcher');

            freshdeskHasLoaded = true;
        }
        return true;
    };

    // Effect to load the Freshdesk widget script.
    useEffect(() => {
        setupFreshDeskScript();
    }, []);

    // Hook function to open the Widget.
    const openFreshDeskWidget = () => window?.FreshworksWidget('open');

    return {
        openFreshDeskWidget
    };
};

export default useFreshDeskWidget;
